module.exports = __webpack_public_path__ + "img/health-insurance.2a7557b.svg";